(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-ct-direction]');
  if (!button) return;
  const carousel = button.closest('.ct-carousel');
  const scroller = carousel && carousel.querySelector('.ct-carousel__scroller');
  const card = scroller && scroller.querySelector('.grid__item');
  if (!card) return;
  const grid = scroller.querySelector('.ct-carousel__grid');
  const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
  const visibleCards = matchMedia('(max-width: 768px)').matches ? 2 : 4;
  scroller.scrollBy({
    left: Number(button.dataset.ctDirection) * visibleCards * (card.getBoundingClientRect().width + gap),
    behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
  });
});

  } catch(e) { console.error(e); }
})();
})();
